import React from "react";
import { useTranslation } from "react-i18next";
import NumberCounter from "./NumberCounter";
import { isRtlLanguage } from "../../utils/i18n";
import ScrollReveal, { revealItemProps } from "./Reveal";

function Numbers() {
  const { i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);

  return (
    <ScrollReveal
      stagger
      className={`flex min-h-[100px] flex-col sm:flex-row ${isRtl ? "sm:flex-row-reverse" : ""}`}
    >
      <div
        {...revealItemProps(
          0,
          "flex w-full flex-1 items-center justify-center bg-gray-800 px-4 py-6 sm:py-0",
        )}
      >
        <span className="pe-3 text-4xl font-semibold text-white sm:text-5xl">
          <NumberCounter targetNumber={18} />
        </span>
        <span className="text-start text-[15px] font-normal leading-5 text-white md:text-[20px]">
          Years of <br />
          Experienced
        </span>
      </div>
      <div
        {...revealItemProps(
          1,
          "flex w-full flex-1 items-center justify-center bg-[#00a44f] px-4 py-6 sm:py-0",
        )}
      >
        <span className="pe-3 text-4xl font-semibold text-white sm:text-5xl">
          <NumberCounter targetNumber={860} />
        </span>
        <p className="text-start text-[15px] font-normal leading-5 text-white md:text-[20px]">
          Project
          <br />
          Done
        </p>
      </div>
    </ScrollReveal>
  );
}

Numbers.revealManaged = true;

export default Numbers;
